import {ChangeDetectionStrategy, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {observeMutations, setStyle, transitionEnd} from 'app/core/helpers/dom';
import {Subscription} from 'rxjs';

@Component({
    selector: 'animated-content',
    templateUrl: './animated-content.component.html',
    styleUrls: ['./animated-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AnimatedContentComponent implements OnInit, OnDestroy {
    @Output() heightContent: EventEmitter<number> = new EventEmitter<number>();
    private mutationSubscription = Subscription.EMPTY;

    constructor(private el: ElementRef<HTMLElement>) {}

    ngOnInit() {
        this.mutationSubscription = observeMutations(this.el.nativeElement, {childList: true, subtree: true}).subscribe(() => {
            let {nativeElement} = this.el;
            let contentGap = 8;
            this.heightContent.emit(nativeElement.childElementCount ? nativeElement.firstElementChild.scrollHeight - contentGap : 0);
            this.updateHeight();
        });
        this.updateHeight();
    }

    ngOnDestroy() {
        this.mutationSubscription.unsubscribe();
    }

    private updateHeight() {
        let {nativeElement} = this.el;
        setStyle(nativeElement, {
            overflow: 'hidden',
            height: `${nativeElement.childElementCount ? nativeElement.firstElementChild.scrollHeight : 0}px`,
            'transition-delay': '0s',
        });
        nativeElement.classList.toggle('opened', !!nativeElement.childElementCount);
        transitionEnd(nativeElement, ['height'], 200).then(() =>
            setStyle(nativeElement, {
                overflow: 'visible',
                'transition-delay': '',
            })
        );
    }
}
